import Vue from 'vue';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import { sync } from 'vuex-router-sync';
import store from './store';

sync(store, router);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
